/* eslint-disable */
/// This file is auto generated - do not edit manually
export const ConfirmTitle = 'Website.Booking.BookingFlow.POS.ConfirmTitle';
export const AddedToBasket = 'Website.Booking.BookingFlow.POS.AddedToBasket';
export const TicketsReserved = 'Website.Booking.BookingFlow.POS.TicketsReserved';
export const OnlyOneLinePossible = 'Website.Booking.BookingFlow.POS.OnlyOneLinePossible';
